const communicationPreferencesForm = () => {
	const form = document.querySelector('.js-communication-preferences-form');

	if (form) {
		const fieldset = form.querySelector('fieldset');
		const steps = form.querySelectorAll('[data-step]');
		const introText = form.querySelector('.intro__text');

		fieldset.removeAttribute('disabled');
		
		form.addEventListener('submit', (e) => {
			e.preventDefault()

			const data = new FormData(form);

			fieldset.setAttribute('disabled', true);

			setTimeout(() => {
				fieldset.removeAttribute('disabled');				
			}, 1000);

			console.log(data)

			if (introText) {
				introText.parentNode.removeChild(introText);
			}

			steps.forEach((step, i) => {
				if (i === 0) {
					step.classList.add('is-d-none')
				}
				if (i === 1) {
					step.classList.remove('is-d-none')
				}
			})
		});
	}
}

communicationPreferencesForm()